export default __webpack_public_path__ + "static/media/banner-happy-new-year-sm.d739529a.png";